import { __decorate } from 'tslib';
import { ReactWrapperComponent, AngularReact, registerElement } from '@angular-react/core';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, ViewChild, Input, Output, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { Styled } from '@angular-react/fabric/lib/utils';
import { CommonModule } from '@angular/common';
import { Checkbox } from '@fluentui/react/lib/Checkbox';

let FabCheckboxComponent = class FabCheckboxComponent extends ReactWrapperComponent {
    constructor(elementRef, changeDetectorRef, renderer, ngZone) {
        super(elementRef, changeDetectorRef, renderer, { ngZone });
        this.onChange = new EventEmitter();
        /* Non-React props, more native support for Angular */
        // support for two-way data binding for `@Input() checked`.
        this.checkedChange = new EventEmitter();
        // coming from React context - we need to bind to this so we can access the Angular Component properties
        this.onChangeHandler = this.onChangeHandler.bind(this);
    }
    ngOnInit() {
        this.onRenderLabel = this.createRenderPropHandler(this.renderLabel);
    }
    onChangeHandler(ev, checked) {
        this.onChange.emit({
            ev: ev && ev.nativeEvent,
            checked,
        });
        this.checkedChange.emit(checked);
    }
};
/** @nocollapse */ FabCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabCheckboxComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ FabCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.1", type: FabCheckboxComponent, selector: "fab-checkbox", inputs: { componentRef: "componentRef", className: "className", checked: "checked", defaultChecked: "defaultChecked", label: "label", disabled: "disabled", inputProps: "inputProps", boxSide: "boxSide", theme: "theme", ariaLabel: "ariaLabel", ariaLabelledBy: "ariaLabelledBy", ariaDescribedBy: "ariaDescribedBy", ariaPositionInSet: "ariaPositionInSet", ariaSetSize: "ariaSetSize", checkmarkIconProps: "checkmarkIconProps", styles: "styles", renderLabel: "renderLabel" }, outputs: { onChange: "onChange", checkedChange: "checkedChange" }, viewQueries: [{ propertyName: "reactNodeRef", first: true, predicate: ["reactNode"], descendants: true, static: true }], exportAs: ["fabCheckbox"], usesInheritance: true, ngImport: i0, template: `
    <Checkbox
      #reactNode
      [componentRef]="componentRef"
      [className]="className"
      [checked]="checked"
      [defaultChecked]="defaultChecked"
      [label]="label"
      [disabled]="disabled"
      [inputProps]="inputProps"
      [boxSide]="boxSide"
      [theme]="theme"
      [ariaLabel]="ariaLabel"
      [ariaLabelledBy]="ariaLabelledBy"
      [ariaDescribedBy]="ariaDescribedBy"
      [ariaPositionInSet]="ariaPositionInSet"
      [ariaSetSize]="ariaSetSize"
      [checkmarkIconProps]="checkmarkIconProps"
      [styles]="styles"
      [RenderLabel]="renderLabel && onRenderLabel"
      [Change]="onChangeHandler"
    >
    </Checkbox>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
FabCheckboxComponent = __decorate([
    AngularReact(),
    Styled('FabCheckboxComponent')
], FabCheckboxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabCheckboxComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fab-checkbox',
                    exportAs: 'fabCheckbox',
                    template: `
    <Checkbox
      #reactNode
      [componentRef]="componentRef"
      [className]="className"
      [checked]="checked"
      [defaultChecked]="defaultChecked"
      [label]="label"
      [disabled]="disabled"
      [inputProps]="inputProps"
      [boxSide]="boxSide"
      [theme]="theme"
      [ariaLabel]="ariaLabel"
      [ariaLabelledBy]="ariaLabelledBy"
      [ariaDescribedBy]="ariaDescribedBy"
      [ariaPositionInSet]="ariaPositionInSet"
      [ariaSetSize]="ariaSetSize"
      [checkmarkIconProps]="checkmarkIconProps"
      [styles]="styles"
      [RenderLabel]="renderLabel && onRenderLabel"
      [Change]="onChangeHandler"
    >
    </Checkbox>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: i0.NgZone }]; }, propDecorators: { reactNodeRef: [{
                type: ViewChild,
                args: ['reactNode', { static: true }]
            }], componentRef: [{
                type: Input
            }], className: [{
                type: Input
            }], checked: [{
                type: Input
            }], defaultChecked: [{
                type: Input
            }], label: [{
                type: Input
            }], disabled: [{
                type: Input
            }], inputProps: [{
                type: Input
            }], boxSide: [{
                type: Input
            }], theme: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input
            }], ariaDescribedBy: [{
                type: Input
            }], ariaPositionInSet: [{
                type: Input
            }], ariaSetSize: [{
                type: Input
            }], checkmarkIconProps: [{
                type: Input
            }], styles: [{
                type: Input
            }], renderLabel: [{
                type: Input
            }], onChange: [{
                type: Output
            }], checkedChange: [{
                type: Output
            }] } });

// Copyright (c) Microsoft Corporation. All rights reserved.
const components = [FabCheckboxComponent];
class FabCheckboxModule {
    constructor() {
        // Add any React elements to the registry (used by the renderer).
        registerElement('Checkbox', () => Checkbox);
    }
}
/** @nocollapse */ FabCheckboxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabCheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ FabCheckboxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabCheckboxModule, declarations: [FabCheckboxComponent], imports: [CommonModule], exports: [FabCheckboxComponent] });
/** @nocollapse */ FabCheckboxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabCheckboxModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: components,
                    exports: components,
                    schemas: [NO_ERRORS_SCHEMA],
                }]
        }], ctorParameters: function () { return []; } });

// Copyright (c) Microsoft Corporation. All rights reserved.

/**
 * Generated bundle index. Do not edit.
 */

export { FabCheckboxComponent, FabCheckboxModule };
